import { jsxs as n, jsx as r } from "react/jsx-runtime";
import { Alert as t, AlertTitle as a, Stack as i, Box as c, Typography as p } from "@mui/material";
import { l, m as d } from "../../index-DVHhaa_b.js";
const h = ({ title: o, children: e }) => /* @__PURE__ */ n(t, { color: "info", icon: /* @__PURE__ */ r(l, { iconType: d.Info }), children: [
  /* @__PURE__ */ r(a, { children: o }),
  /* @__PURE__ */ r(i, { direction: "row", gap: 2, flexWrap: "wrap", pt: 1, rowGap: 1, children: e })
] }), f = ({ color: o, label: e }) => /* @__PURE__ */ n(i, { direction: "row", spacing: 1, alignItems: "center", children: [
  /* @__PURE__ */ r(c, { bgcolor: o, width: 15, height: 15, borderRadius: "50%" }),
  /* @__PURE__ */ r(p, { variant: "caption", children: e })
] });
export {
  h as Legend,
  f as LegendItem
};
//# sourceMappingURL=index.js.map
